<div class="anc-segmented" role="tablist">
    @for (option of visibleOptions(); track option.value) {
        <button
            type="button"
            role="tab"
            class="anc-segmented__option"
            [class.anc-segmented__option--active]="option.value === activeValue()"
            [attr.aria-selected]="option.value === activeValue()"
            (click)="onSelect(option)"
        >
            @if (option.dot) {
                <span
                    class="anc-segmented__dot"
                    [ngClass]="'anc-segmented__dot--' + option.dot"
                ></span>
            }
            <span class="anc-segmented__label" translate>{{ option.label | translate }}</span>
        </button>
    }
</div>
